
export const studyBackgroundImages = [
    "/img/dashboard/DashboardstudiesBG1.png",
    "/img/dashboard/DashboardstudiesBG2.png",
    "/img/dashboard/DashboardstudiesBG3.png",
    "/img/dashboard/DashboardstudiesBG4.png",
    "/img/dashboard/DashboardstudiesBG5.png",
    "/img/dashboard/DashboardstudiesBG6.png",
    "/img/dashboard/DashboardstudiesBG7.png",
    "/img/dashboard/DashboardstudiesBG8.png",
    "/img/dashboard/DashboardstudiesBG9.png",
    "/img/dashboard/DashboardstudiesBG10.png",
    "/img/dashboard/DashboardstudiesBG11.png",
    "/img/dashboard/DashboardstudiesBG12.png",
    "/img/dashboard/DashboardstudiesBG13.png",
    "/img/dashboard/DashboardstudiesBG14.png",
    "/img/dashboard/DashboardstudiesBG15.png",
    "/img/dashboard/DashboardstudiesBG16.png",
    "/img/dashboard/DashboardstudiesBG17.png",
    "/img/dashboard/DashboardstudiesBG18.png",
    "/img/dashboard/DashboardstudiesBG19.png",
    "/img/dashboard/DashboardstudiesBG20.png",
  ]
  

  export const getRandomBackground = () => {
    const randomIndex = Math.floor(Math.random() * studyBackgroundImages.length)
    return studyBackgroundImages[randomIndex]
  }
  